import { RemainingLeavesShared } from 'common/components/shared/LeaveComponents';
import { getEmplopyeeRemainingLeaves } from 'leaveAndHolidays/redux.actions';

const RemainingLeaves = ({ year }) => {
    return (
        <RemainingLeavesShared
            year={year}
            title="Leaves Summary"
            fetchAction={getEmplopyeeRemainingLeaves}
        />
    );
};

export default RemainingLeaves;
